import { createUseStyles } from 'react-jss';
export const usePopoverPanelStyles = createUseStyles(() => ({
    popoverPanel: {
        border: '1px solid #E1E4EA',
        borderRadius: '16px',
        backgroundColor: '#fff',
        marginTop: '0.5rem',
        marginBottom: '0.5rem',
        width: 'fit-content',
        boxShadow: '0px 16px 32px -12px rgba(14, 18, 27, 0.1)'
    }
}));
